// extracted by mini-css-extract-plugin
export default {"mouseFollower":"MouseFollower_mouseFollower__EEu-C","hovering":"MouseFollower_hovering__eKXjv","label":"MouseFollower_label__jxWGC"};